import React, { useContext, useEffect } from 'react'
import { TextField } from "@mui/material"
import { LoadingContext } from '../M_Utils'
import { useTranslation } from 'react-i18next'

export function M_TextArea({ label, value, required, disabled, color,
    secondColor, rows, helperText, onChange, size, margin, translate, blockSpecialChars }) {
    const ctx = useContext(LoadingContext)
    const { t } = useTranslation()
    
    color = color ? color : ctx.primaryColor ? ctx.primaryColor : 'var(--color-black)'
    secondColor = secondColor ? secondColor : ctx.secondaryColor ? ctx.secondaryColor : 'var(--color-black)'

    const handleInternalChange = (e) => {
        if (!onChange || typeof onChange !== 'function') {
            return;
        }

        if (blockSpecialChars) {
            const cleanedValue = e.target.value.normalize('NFD').replace(/[\u0300-\u036f´`~^¨¸]/g, '');
            
            // Cria um novo objeto de evento fake para manter a compatibilidade com o onChange original
            const fakeEvent = {
                ...e,
                target: { ...e.target, value: cleanedValue }
            };
            onChange(fakeEvent);
        } else {
            onChange(e);
        }
    };

    

    return (<TextField
        sx={{
            margin: margin,
            width: size ? size : null,
            '& label': { color: secondColor ? secondColor : 'var(--color-black)' },
            '& label.Mui-focused': { color: secondColor ? secondColor : 'var(--color-black)' },
            '& .MuiInput-underline:after': { borderBottomColor: color ? color : 'var(--color-black)' },
            "& .MuiInputBase-root.Mui-disabled": {
                "& > fieldset": {
                    borderColor: 'rgba(0, 0, 0, 0.38) !important'
                }
            },
            '& .MuiOutlinedInput-root': {
                '& fieldset': {
                    borderColor: color ? color : 'var(--color-black)',
                },
                '&:hover fieldset': {
                    borderColor: color ? color : 'var(--color-black)',
                },
                '&.Mui-focused fieldset': {
                    borderColor: color ? color : 'var(--color-black)',
                },
                "& legend": {
                    letterSpacing: -1.9
                }
            }
        }}
        margin="dense"
        required={required}
        disabled={disabled}
        fullWidth
        variant="outlined"
        slotProps={{
            inputLabel:{ autoComplete: "none", shrink: true }
        }}
        label={translate && t(label) || label}
        value={value}
        //onChange={onChange}
        onChange={handleInternalChange}
        multiline
        rows={rows ? rows : 3}
        helperText={helperText}
    />
    )
}